import React from "react"
import { Link } from "gatsby"
import { VeraImage } from "../elements/vera-image"
import { profileScore } from "../dynamic-components/product/product"

const AsideTeaser = props => {
  const { teaser } = props
  if (teaser.every(el => !el)) {
    return null
  }
  return (
    <div className="section-aside-teaser">
      <h5
        className="has-text-centered"
        style={{ fontSize: "1.125rem", fontWeight: "bold", paddingTop: "2rem" }}
      >
        You might wanna try:
      </h5>
      {teaser.map(item => {
        if (!item) {
          return null
        }
        if (item._type === "article") {
          return (
            <div
              style={{ fontSize: "1.375rem" }}
              key={item._id}
              className="teaser"
            >
              <Link
                to={`/article/${item.slug.current}/`}
                className="link-title text-link"
              >
                {item.article_title}
              </Link>
            </div>
          )
        } else if (item._type === "recipe") {
          return (
            <div
              style={{ fontSize: "1.375rem" }}
              key={item._id}
              className="teaser"
            >
              <Link
                to={`/recipe/${item.slug.current}/`}
                className="link-title text-link"
              >
                {item.recipe_title}
              </Link>
            </div>
          )
        } else if (item._type === "product") {
          if (
            !item.product_variants ||
            !item.product_variants.variants ||
            item.product_variants.variants.length < 1
          ) {
            return null
          }
          if (!item.product_collection) {
            return null
          }
          return (
            <div key={item._id} className="teaser">
              <Link
                to={`/shop/${item.product_collection.slug.current}/${item.slug.current}/`}
                className="link-title"
              >
                <div className="product">
                  <div className="product__image-wrapper transform-animate">
                    <VeraImage asset={item.product_image.asset} contain />
                  </div>
                  <div className="product__title has-text-centered">
                    {item.product_name}
                  </div>
                  <div
                    className="product__info--teaser"
                    style={
                      item.product_flavor_profile &&
                      item.product_flavor_profile.score &&
                      item.product_flavor_profile.score.length > 1 &&
                      item.product_flavor_profile.score[0].title &&
                      item.product_flavor_profile.score[0].score
                        ? {}
                        : { justifyContent: "center" }
                    }
                  >
                    {item.product_flavor_profile &&
                      item.product_flavor_profile.score &&
                      item.product_flavor_profile.score.length > 1 &&
                      item.product_flavor_profile.score[0].title &&
                      item.product_flavor_profile.score[0].score && (
                        <div className="product__score--teaser">
                          {
                            <p>
                              {item.product_flavor_profile.score[0].title}:{" "}
                              <span className="product__score-indicator--teaser">
                                {item.product_flavor_profile.score[0].score}/6
                              </span>
                            </p>
                          }
                        </div>
                      )}
                    <div className="product__price--teaser">
                      {item.product_variants.variants[0].variant_info_price} DKK
                    </div>
                  </div>
                  <div className="product__background-overlay"></div>
                </div>
              </Link>
            </div>
          )
        }
      })}
    </div>
  )
}

export default AsideTeaser
